<template>
    <KebabMenu
        v-if="props.sort?.length"
        icon="sort" sprite="navigation"
        :leftAuto="!locale.rtl"
        :rightAuto="locale.rtl"
        :tertiary="!props.code"
        size="size-m"
    >
        <ul>
            <li v-for="(item, id) in props.sort"
                :key="id"
                :class="{ selected: item.code === props.code }"
                @click="setSort(item)"
            >
                <Icon :icon="item.icon" :sprite="item.sprite" />
                <span>{{ t(item.name) }}</span>

                <Icon icon="check" sprite="actions" class="check" v-show="item.code === props.code" />
            </li>
        </ul>
    </KebabMenu>
</template>

<script setup>
    import { useI18n } from 'vue-i18n';
    import KebabMenu from '🔗/components/ui/KebabMenu.vue';
    import stores from '@/stores';

    const locale = stores.locale();

    const { t } = useI18n();
    const emit = defineEmits(['change']);

    const props = defineProps({
        sort: { type: Array, default: () => ([]) },
        code: { type: [String, null], default: null }
    });

    const setSort = (item) => {
        emit('change', item);
    };
</script>

<style lang="scss" scoped>
</style>
